import { useState } from "react";
import Modal from "@/components/base/Modal";
import { getDataClient } from "@/lib/dataClient";

const BRANSLAR = [
  "Matematik", "Geometri", "Türkçe", "Fizik", "Kimya", "Biyoloji",
  "Tarih", "Coğrafya", "Felsefe", "İngilizce",
];

const ILLER = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
  "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik",
  "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum",
  "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir",
  "Gaziantep", "Giresun", "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul",
  "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale",
  "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa",
  "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye",
  "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak",
  "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak",
];

interface TeacherAddModalProps {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}

const inputClass =
  "w-full h-10 px-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none transition-colors";

const labelClass = "block text-sm font-semibold text-foreground-800 mb-1.5";

export default function TeacherAddModal({ open, onClose, onSaved }: TeacherAddModalProps) {
  const [adSoyad, setAdSoyad] = useState("");
  const [brans, setBrans] = useState("");
  const [sehir, setSehir] = useState("");
  const [ilce, setIlce] = useState("");
  const [telefon, setTelefon] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [adres, setAdres] = useState("");
  const [dogumTarihi, setDogumTarihi] = useState("");
  const [cinsiyet, setCinsiyet] = useState("");
  const [deneyim, setDeneyim] = useState("");
  const [egitim, setEgitim] = useState("");
  const [biyografi, setBiyografi] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const reset = () => {
    setAdSoyad("");
    setBrans("");
    setSehir("");
    setIlce("");
    setTelefon("");
    setEmail("");
    setPassword("");
    setAdres("");
    setDogumTarihi("");
    setCinsiyet("");
    setDeneyim("");
    setEgitim("");
    setBiyografi("");
    setError("");
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const dataClient = getDataClient();
      const { data, error: invokeError } = await dataClient.functions.invoke("create-teacher", {
        body: {
          email,
          password,
          ad_soyad: adSoyad,
          brans,
          sehir,
          ilce,
          telefon,
          adres,
          dogum_tarihi: dogumTarihi,
          cinsiyet,
          deneyim,
          egitim,
          biyografi,
        },
      });

      if (invokeError) {
        // FunctionsHttpError durumunda sunucunun gerçek hata mesajını çıkar.
        let serverMsg = "";
        const err = invokeError as { context?: Response; message?: string };
        if (err?.context && typeof err.context.json === "function") {
          try {
            const body = (await err.context.json()) as { error?: string; message?: string };
            serverMsg = body?.error || body?.message || "";
          } catch {
            // mesaj okunamazsa boş bırak
          }
        }
        throw new Error(
          serverMsg ||
            (typeof invokeError === "string"
              ? invokeError
              : invokeError?.message || "Öğretmen eklenemedi."),
        );
      }

      if (!data?.ok) {
        throw new Error(data?.error || "Öğretmen eklenemedi.");
      }

      reset();
      onSaved();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Öğretmen eklenemedi.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Öğretmen Ekle"
      titleId="teacher-add-title"
      id="teacher-add-modal"
      maxWidthClass="max-w-2xl"
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <p className="text-sm text-foreground-600 leading-relaxed">
          Yeni öğretmenin hesabını ve profil bilgilerini oluştur. Öğretmen, belirlediğin
          e-posta ve şifreyle giriş yapabilecek.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2">
            <label htmlFor="teacher-add-name" className={labelClass}>
              Ad Soyad <span className="text-accent-600">*</span>
            </label>
            <input
              id="teacher-add-name"
              type="text"
              value={adSoyad}
              onChange={(e) => setAdSoyad(e.target.value)}
              required
              autoComplete="off"
              placeholder="Öğretmenin adı soyadı"
              className={inputClass}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-brans" className={labelClass}>
              Branş <span className="text-accent-600">*</span>
            </label>
            <select
              id="teacher-add-brans"
              value={brans}
              onChange={(e) => setBrans(e.target.value)}
              required
              className={`${inputClass} cursor-pointer`}
            >
              <option value="" disabled>
                Branş seçin
              </option>
              {BRANSLAR.map((b) => (
                <option key={b} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="teacher-add-sehir" className={labelClass}>
              İl <span className="text-accent-600">*</span>
            </label>
            <select
              id="teacher-add-sehir"
              value={sehir}
              onChange={(e) => setSehir(e.target.value)}
              required
              className={`${inputClass} cursor-pointer`}
            >
              <option value="" disabled>
                İl seçin
              </option>
              {ILLER.map((il) => (
                <option key={il} value={il}>
                  {il}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="teacher-add-ilce" className={labelClass}>
              İlçe
            </label>
            <input
              id="teacher-add-ilce"
              type="text"
              value={ilce}
              onChange={(e) => setIlce(e.target.value)}
              autoComplete="off"
              placeholder="Ör. Çankaya"
              className={inputClass}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-telefon" className={labelClass}>
              Telefon <span className="text-accent-600">*</span>
            </label>
            <input
              id="teacher-add-telefon"
              type="tel"
              value={telefon}
              onChange={(e) => setTelefon(e.target.value)}
              required
              autoComplete="off"
              placeholder="05XX XXX XX XX"
              className={inputClass}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-email" className={labelClass}>
              E-posta <span className="text-accent-600">*</span>
            </label>
            <input
              id="teacher-add-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="off"
              placeholder="ornek@mail.com"
              className={inputClass}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-password" className={labelClass}>
              Geçici Şifre <span className="text-accent-600">*</span>
            </label>
            <input
              id="teacher-add-password"
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="off"
              placeholder="En az 8 karakter"
              className={inputClass}
            />
            <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
              Bu şifreyi öğretmenle paylaş. Öğretmen daha sonra profilinden değiştirebilir.
            </p>
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="teacher-add-adres" className={labelClass}>
              Adres
            </label>
            <textarea
              id="teacher-add-adres"
              value={adres}
              onChange={(e) => setAdres(e.target.value)}
              maxLength={500}
              rows={2}
              placeholder="Açık adres bilgisi"
              className={`${inputClass} h-auto py-2 resize-none`}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-dogum" className={labelClass}>
              Doğum Tarihi
            </label>
            <input
              id="teacher-add-dogum"
              type="date"
              value={dogumTarihi}
              onChange={(e) => setDogumTarihi(e.target.value)}
              className={`${inputClass} cursor-pointer`}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-cinsiyet" className={labelClass}>
              Cinsiyet
            </label>
            <select
              id="teacher-add-cinsiyet"
              value={cinsiyet}
              onChange={(e) => setCinsiyet(e.target.value)}
              className={`${inputClass} cursor-pointer`}
            >
              <option value="">Belirtilmedi</option>
              <option value="Kadın">Kadın</option>
              <option value="Erkek">Erkek</option>
            </select>
          </div>

          <div>
            <label htmlFor="teacher-add-deneyim" className={labelClass}>
              Deneyim (Yıl)
            </label>
            <input
              id="teacher-add-deneyim"
              type="number"
              min={0}
              max={60}
              value={deneyim}
              onChange={(e) => setDeneyim(e.target.value)}
              autoComplete="off"
              placeholder="Ör. 10"
              className={inputClass}
            />
          </div>

          <div>
            <label htmlFor="teacher-add-egitim" className={labelClass}>
              Eğitim / Mezuniyet
            </label>
            <input
              id="teacher-add-egitim"
              type="text"
              value={egitim}
              onChange={(e) => setEgitim(e.target.value)}
              autoComplete="off"
              placeholder="Ör. ODTÜ Matematik Öğretmenliği"
              className={inputClass}
            />
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="teacher-add-biyografi" className={labelClass}>
              Biyografi
            </label>
            <textarea
              id="teacher-add-biyografi"
              value={biyografi}
              onChange={(e) => setBiyografi(e.target.value)}
              maxLength={500}
              rows={3}
              placeholder="Öğretmen hakkında kısa açıklama"
              className={`${inputClass} h-auto py-2 resize-none`}
            />
          </div>
        </div>

        {error && (
          <div className="rounded-md bg-accent-100/70 text-accent-800 px-3 py-2.5 text-sm">
            {error}
          </div>
        )}

        <div className="flex items-center gap-3 pt-1">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-10 rounded-md border border-background-200 bg-background-50 text-foreground-700 text-sm font-semibold whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
          >
            Vazgeç
          </button>
          <button
            type="submit"
            disabled={saving}
            className="flex-1 h-10 flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors cursor-pointer"
          >
            {saving ? (
              <>
                <i className="ri-loader-4-line animate-spin" aria-hidden="true"></i>
                Ekleniyor...
              </>
            ) : (
              "Öğretmeni Ekle"
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}